import { FC, useCallback, useState } from "react";
import { useParams } from "react-router-dom";
import useFetch from "../../../../hooks/useFetch";
import FormGroup from "../../../../layout/shared/form-group";
import { Input, Textarea } from "rizzui";
import {appSelectors, carrionPresentSelector, cloudCover, windDirectionsSpanish, windSpeed } from "../../../../utils/SelectorMapping";
import { usePrivilege } from "../../../../components/priviledge/PriviledgeProvider";
import { StopsService } from "../../../../services/preventive-stops/stopsService";
import StopsProfileLayout from "../StopsProfileLayout";
import moment from "moment";


interface StopsInfoProps {
    
}


const StopsInfo: FC<StopsInfoProps> = () => {
    
    // STATES

    const [isRefecth, setIsRefecth] = useState<boolean>(true);

    // HOOKS

    const { id = '' } = useParams<{ id: string }>();
    const { userCan } = usePrivilege();
    const service = new StopsService();

    // DATA FETCHING

    const [data, loading, error, refetch] = useFetch(useCallback(async () => {
        if (!id || id === '' || isRefecth == false) return null;
        if (isRefecth) setIsRefecth(false);

        const response = await service.getStopsById(id);
        return response.getResponseData();
    }, [id, isRefecth]));

    // RENDER

    return (
        <>
            <div className="@container">
                <FormGroup
                    title="Datos de la parada"
                    description='Información de la parada'
                    className='pt-3 pb-4'
                    titleCols="@md:col-span-12"
                    childCols="@md:col-span-12 "
                >
                    {userCan('list','companies') && (
                        <div className="grid md:grid-cols-1 grid-cols-1 gap-2" >
                            <Input
                                disabled
                                label="Compañia"
                                placeholder="Compañia"
                                value={data?.company?.name ?? ''}
                            />
                        </div>
                    )}
                    <div className={`grid grid-cols-1 gap-2`} >
                        <Input
                            disabled
                            label="Id"
                            placeholder="Id"
                            value={data?.stopCode ?? ''}
                        />
                    </div>

                    <div className="grid md:grid-cols-2 grid-cols-1 gap-2 mb-4" >
                        <Input
                            disabled
                            label="Parque eólico"
                            placeholder="Parque"
                            value={data?.park?.name ?? ''}
                        />
                        <Input
                            disabled
                            label="Observador"
                            placeholder="Observador"
                            value={(data?.user?.name ?? '') + ' ' + (data?.user?.lastName ?? '')}
                        />
                    </div>

                    <div className="grid md:grid-cols-4 grid-cols-1 gap-2" >
                        <Input
                            disabled
                            label="Fecha de la parada"
                            placeholder="Parada el día"
                            value={data?.stopDate?.date ? new Date(data?.stopDate?.date).toLocaleDateString('es-ES', {
                                year: 'numeric',
                                month: '2-digit',
                                day: '2-digit',
                            }) : 'Sin fecha'}
                        />
                    </div>

                    <div className="grid md:grid-cols-4 grid-cols-1 gap-2" >

                        <Input
                            disabled
                            label="Hora de llamada"
                            placeholder="Emision a las"
                            value={data?.startTime?.date ? moment(data?.startTime?.date).format('HH:mm') : 'Sin hora'}
                        />

                        <Input
                            disabled
                            label="Hora de parada"
                            placeholder="Parada a las"
                            value={data?.stopTime?.date ? moment(data?.stopTime?.date).format('HH:mm') : 'Sin hora'}
                        />

                        <Input
                            disabled
                            label="Hora fin"
                            placeholder="Solicitud a las"
                            value={data?.resumeOrderTime?.date ? moment(data?.resumeOrderTime?.date).format('HH:mm') : 'Sin hora'}
                        />

                        <Input
                            disabled
                            label="Hora Arranque"
                            placeholder="Reactivación a las"
                            value={data?.resumeTime?.date ? moment(data?.resumeTime?.date).format('HH:mm') : 'Sin hora'}
                        />
                    </div>

                    <div className="grid md:grid-cols-3 grid-cols-1 gap-2" >
                        <Input
                            disabled
                            label="Dirección del viento"
                            placeholder="Dirección del viento"
                            value={
                                data?.windDirection
                                ? windDirectionsSpanish.find(option => option.value == data?.windDirection)?.label ?? 'Sin datos'
                                : 'Sin datos'
                            }
                        />
                       <Input
                            disabled
                            label="Intensidad del viento"
                            placeholder="Intensidad del viento"
                            value={
                                data?.windSpeed == 0 || data?.windSpeed !== null
                                ? windSpeed.find(option => option.value == String(data?.windSpeed))?.label ?? 'Sin datos'
                                : 'Sin datos'
                            }
                        />
                        <Input
                            disabled
                            label="Cobertura de nubes"
                            placeholder="Cobertura de nubes"
                            value={
                                data?.cloudCoverage == 0 || data?.cloudCoverage !== null
                                ? cloudCover.find(option => option.value == String(data?.cloudCoverage))?.label ?? 'Sin datos'
                                : 'Sin datos'
                            }
                        />
                    </div>

                    <div className="grid md:grid-cols-3 grid-cols-1 gap-2" >
                        <Input
                            disabled
                            label="Número de aerogeneradores"
                            placeholder="Número de aerogeneradores"
                            value={data?.numMachines ?? 'Sin datos'}
                        />   

                        <Input
                            disabled
                            label="Tiempo parado por aerogenerador"
                            placeholder="Tiempo parado por aerogenerador"
                            value={data?.downtimePerMachine ? `${data.downtimePerMachine} min` : 'Sin datos'}  
                        />

                        <Input
                            disabled
                            label="Tiempo total de paradas"
                            placeholder="Tiempo total de paradas"
                            value={data?.totalDowntime ? `${data.totalDowntime} min` : 'Sin datos'}
                        />
                    </div> 
                    
                    <div className="grid md:grid-cols-2 grid-cols-1 gap-2" >
                        <Textarea
                            id='Causa'
                            disabled
                            label='Causa de la parada'
                            rows={6}
                            value={data?.cause ?? ''}
                            onChange={(e) => data?.setFieldValue('cause', e.target.value)}
                            className="mb-4"
                            
                        />

                        <Textarea
                            id='Comments'
                            disabled
                            label='Observaciones'
                            rows={6}
                            value={data?.comments ?? ''}
                            onChange={(e) => data?.setFieldValue('comments', e.target.value)}
                            className="mb-4"
                        />
                    </div>

                    <div className={`grid ${data?.stopWithApp === 'no' || data?.restartWithApp === 'no' || data?.stopWithApp === 'partial' || data?.restartWithApp === 'partial' ? 'md:grid-cols-3' : 'md:grid-cols-2'} grid-cols-1 gap-2`} >
                        <Input
                            disabled
                            label="Parada por App"
                            placeholder="Parada por App"
                            value={
                                data?.stopWithApp
                                ? appSelectors.find(option => option.value == data?.stopWithApp)?.label ?? 'Sin datos'
                                : 'Sin datos'
                            }
                        />
                       <Input
                            disabled
                            label="Reactivación por App"
                            placeholder="Reactivación por App"
                            value={
                                data?.restartWithApp
                                ? appSelectors.find(option => option.value == String(data?.restartWithApp))?.label ?? 'Sin datos'
                                : 'Sin datos'
                            }
                        />
                        {data?.stopWithApp === 'no' || data?.restartWithApp === 'no' || data?.stopWithApp === 'partial'  || data?.restartWithApp === 'partial' ? (
                              <Textarea
                              id='appIssue'
                              disabled
                              label='Problemas con la App'
                              rows={4}
                              value={data?.appIssue ?? ''}
                              onChange={(e) => data?.setFieldValue('appIssue', e.target.value)}
                              className="mb-4"
                          />
                        ) : null}
                      
                    </div>

                    <div className="grid md:grid-cols-1 grid-cols-1 gap-2" >
                    <Input
                            disabled
                            label="Carroña presente"
                            placeholder="Carroña presente"
                            value={
                                data?.carrionPresence
                                ? carrionPresentSelector.find(option => option.value == data?.carrionPresence)?.label ?? 'Sin datos'
                                : 'Sin datos'
                            }
                        />
                    </div>

                    <div className="grid md:grid-cols-1 grid-cols-1 gap-2" >
                        <Textarea
                            id='additionalComments'
                            disabled
                            label='Comentarios adicionales'
                            rows={6}
                            value={data?.additionalComments ?? ''}
                            onChange={(e) => data?.setFieldValue('additionalComments', e.target.value)}
                            className="mb-4"
                        />
                    </div>

                    <hr className="border-t-2 border-gray-300 my-4"/>
                    
                    <div className="grid md:grid-cols-1 grid-cols-1 gap-2" >
                        <FormGroup
                            title="Otros datos relevantes"
                            description='Información de los aerogeneradores y de las especies involucrados en la parada'
                            className='pt-3 pb-4'
                            titleCols="@md:col-span-12"
                            childCols="@md:col-span-12 "
                        >

                            <FormGroup
                                title="Aerogeneradores"
                                className='pt-3 pb-4'
                                titleCols="@md:col-span-12"
                                childCols="@md:col-span-12 "
                            >
                                {data?.windTurbinesPreventiveStops && data?.windTurbinesPreventiveStops.length > 0 && (
                                    <div className="grid md:grid-cols-1 grid-cols-1 gap-2">
                                        {data.windTurbinesPreventiveStops.map((stop:any, index:any) => (
                                            <div key={index} className="grid grid-cols-2 gap-4 p-2 border rounded shadow">
                                                <span className="font-bold">Nombre:</span>
                                                <span>{stop.windTurbine?.name ?? ''}</span>
                                                <span className="font-bold">Tiempo de parada:</span>
                                                <span>{stop.stopTime?.date ? moment(stop.stopTime?.date).format('HH:mm') : 'No disponible'}</span>
                                                <span className="font-bold">Tiempo de reactivación:</span>
                                                <span>{stop.resumeTime?.date ? moment(stop.resumeTime?.date).format('HH:mm') : 'No reactivada'}</span>
                                            </div>
                                        ))}
                                    </div>
                                )}

                            </FormGroup>


                            <FormGroup
                                title="Especies"
                                className='pt-3 pb-4'
                                titleCols="@md:col-span-12"
                                childCols="@md:col-span-12 "
                            >
                                {data?.speciesPreventiveStops && data?.speciesPreventiveStops.length > 0 && (
                                    <div className="grid md:grid-cols-1 grid-cols-1 gap-2">
                                        {data.speciesPreventiveStops.map((stop:any, index:any) => (
                                            <div key={index} className="grid grid-cols-2 gap-4 p-2 border rounded shadow">
                                                <span className="font-bold">Nombre científico:</span>
                                                <span><i className="italic">{stop.species?.scientificName ?? ''}</i></span>
                                                <span className="font-bold">Nombre común:</span>
                                                <span>{stop.species?.commonName ?? ''}</span>
                                                <span className="font-bold">Número de individuos:</span>
                                                <span>{stop.numIndividuals ?? 'Sin contabilizar'}</span>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </FormGroup>

                        </FormGroup>
                    </div>



                </FormGroup>
            </div>
        </>
    )
    

}

export default StopsInfo;